const NeighborhoodMap = {
    mobileBreakpoint: 990,

    init() {
        if( this.cacheDom() ) {
            this.bindEvents();
        }
    },

    cacheDom() {
        this.map = document.querySelector('[data-neighborhood-map]');
        if( !this.map ) return false;

        this.titles = this.map.querySelectorAll('.hood-title');

        const hoods = Array.from(this.titles).reduce((acc, title) => {
            const id = title.id
            const selector = `.info.${id}`;
            const info = this.map.querySelector(selector);
            const close = info.querySelector('.info-close');
            acc[id] = {
                id,
                title,
                info,
                close,
            };

            return acc;
        }, {});

        this.hoods = hoods;
        
        return this.map && this.titles.length > 0 && Object.keys(this.hoods).length > 0;
    },

    handleMouseover(hood, e) {
        if( this.isAtMobileBreakpoint() ) return;

        this.showInfo(hood.info);
    },

    handleMouseout(hood, e) { 
        if( this.isAtMobileBreakpoint() ) return;
        this.hideInfo(hood.info);
    },

    handleClick(e) {
        if( !this.isAtMobileBreakpoint() ) return;

        
        const hood = e.target.closest('.map-title');
        
        if( hood ) {
            const id = hood.id;
            const info = this.hoods[id].info;
            this.showInfo(info);
            // hood.classList.add('hover');
        }
    },

    handleClose(e) {
        e.preventDefault();
        e.stopPropagation();
        const hood = e.target.closest('.info');
        if( hood ) {
            this.hideInfo(hood);
        }
    },

    showInfo(info) {
        this.hideAllInfo();
        if( info ) {
            info.classList.add('fly');
        }
    },

    hideInfo(info) {
        if( info ) {
            info.classList.remove('fly');
        }
    },

    hideAllInfo() {
        Object.values(this.hoods).forEach(hood => {
            this.hideInfo(hood.info);
        });
    },

    isAtMobileBreakpoint() {
        return window.matchMedia(`(max-width: ${this.mobileBreakpoint}px)`).matches;
    },

    bindEvents() {

        Object.values(this.hoods).forEach(hood => {
            hood.title.addEventListener('mouseover', this.handleMouseover.bind(this, hood));
            hood.title.addEventListener('mouseout', this.handleMouseout.bind(this, hood));
            hood.title.addEventListener('click', (e) => {
                this.handleClick(e)
            });
            
            hood.close.addEventListener('click', (e) => {
                this.handleClose(e)
            });
        });


        
        // $('.hood').click(function(e){
        //     e.preventDefault();
        //     $('.info').removeClass('fly');
        //     var hood = $(this).find('.hood-title').attr('id');
        //     $('.info.' + hood).addClass('fly');
        // });
        // $('a.info-close').click(function(e){
        //     e.preventDefault();
        //     $('.info').removeClass('fly');
        // });
        
    }
}

export default NeighborhoodMap;